function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M22 12c0 2.76-2.24 5-5 5 0-2.76-2.24-5-5-5 2.76 0 5-2.24 5-5 2.76 0 5 2.24 5 5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 17c-2.76 0-5-2.24-5-5 2.76 0 5 2.24 5 5z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M17 17c0 2.76-2.24 5-5 5s-5-2.24-5-5c2.76 0 5-2.24 5-5 0 2.76 2.24 5 5 5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 7c0 2.76-2.24 5-5 5 0-2.76 2.24-5 5-5z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M17 7c-2.76 0-5 2.24-5 5 0-2.76-2.24-5-5-5 0-2.76 2.24-5 5-5s5 2.24 5 5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 12c0 2.76-2.24 5-5 5 0-2.76 2.24-5 5-5zm0 0c-2.76 0-5-2.24-5-5 2.76 0 5 2.24 5 5z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 12c-2.76 0-5 2.24-5 5-2.76 0-5-2.24-5-5s2.24-5 5-5c0 2.76 2.24 5 5 5z"
})));